import { render, staticRenderFns } from "./businessDetailRefund.vue?vue&type=template&id=be477fe8&scoped=true"
import script from "./businessDetailRefund.vue?vue&type=script&lang=js"
export * from "./businessDetailRefund.vue?vue&type=script&lang=js"
import style0 from "./businessDetailRefund.vue?vue&type=style&index=0&id=be477fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be477fe8",
  null
  
)

export default component.exports